



































































































































































































import { Component, Vue } from "vue-property-decorator";
import { Route } from "vue-router";
import i18n from "@/i18n";
import { Getter, Mutation } from "vuex-class";
import { CurrentUser } from "@/store/authentication/types";
import { UserProfile, Cultures } from "@/services/users/types";
import {
    getUserProfile,
    updateUserProfile
} from "@/services/users/usersService";
import { resetPassword } from "@/services/security/authService";

import { detailsValidators } from "@/components/users/validators";
import validate from "@/directives/validate";

import { TimeZone } from "@/services/timeZones/types";
import { getTimeZones } from "@/services/timeZones/timeZoneService";
import vSelect from "vue-select";
import UnsavedFormModal from "@/components/common/modals/UnsavedFormModal.vue";

const namespace: string = "authentication";
@Component<UserProfileForm>({
    beforeRouteLeave(to, from, next) {
        this.userProfile ? this.userProfile.id ? this.onBeforeRouteLeave(to, next) : next()
            : this.onBeforeRouteLeave(to, next);
    },
    components: {
        vSelect,
        UnsavedFormModal
    },
    directives: {
        validate
    }
})
export default class UserProfileForm extends Vue {
    @Getter("getCurrentUser", { namespace }) getCurrentUser: any;
    @Mutation("updateUserCulture", { namespace }) updateUserCulture: any;
    @Mutation("updateUsername", { namespace }) updateUsername: any

    // local state
    validators = detailsValidators;
    passwordFieldType = "password";
    editPassword: boolean = false;
    timeZones: TimeZone[] = [];
    selectedTimeZone = { id: "", displayName: "" } as TimeZone;
    emailResp = i18n.t("");
    userProfile = {
        id: "",
        firstName: "",
        lastName: "",
        email: "",
        currentPassword: "",
        password: "",
        repeatNewPassword: "",
        jobTitle: "",
        newsletter: false,
        cultureCode: "",
        timezoneId: "",
        timezoneName: ""
    } as UserProfile;

    // used for comparing if form have changes
    localUserProfile = {
        id: "",
        firstName: "",
        lastName: "",
        email: "",
        currentPassword: "",
        password: "",
        repeatNewPassword: "",
        jobTitle: "",
        newsletter: false,
        cultureCode: "",
        timezoneId: "",
        timezoneName: ""
    } as UserProfile;

    nextRoute = "";
    saveClicked = false;
    routeParams = {};

    // computed properties
    get localizedLanguages() {
        return this.getLocalizedCulture();
    }

    get editPasswordText() {
        return this.editPassword ? i18n.t("users.hidePassword") : i18n.t("users.editPassword");
    }

    // methods
    async fetchData() {
        this.timeZones = await getTimeZones();
        const browserLocation = Intl.DateTimeFormat().resolvedOptions().timeZone.split("/")[1];
        const currentUser: CurrentUser = this.getCurrentUser;
        getUserProfile(currentUser.id).then((response: any) => {
            if (response) {
                response.password = "";
                response.repeatNewPassword = "";
                response.currentPassword = "";
                this.userProfile = response;
                this.localUserProfile = JSON.parse(JSON.stringify(this.userProfile));
            }
            if (response.timezoneId) {
                this.selectedTimeZone.displayName = response.timezoneName;
                this.selectedTimeZone.id = response.timezoneId;
            } else {
                const localTimeZone = this.timeZones.find(x => x.displayName.includes(browserLocation));
                this.selectedTimeZone.id = localTimeZone ? localTimeZone.id : "";
                this.selectedTimeZone.displayName = localTimeZone ? localTimeZone.displayName : "";
            }
        });
    }

    onBeforeRouteLeave(to: Route, next: any) {
        if (this.nextRoute === "" && !this.saveClicked) {
            this.nextRoute = to.name ? to.name : "";
            this.routeParams = to.params;
            JSON.stringify(this.localUserProfile) === JSON.stringify(this.userProfile) ? next() : (this.$refs.UnsavedFormModal as any).open();
        } else {
            next();
        }
    }

    onContinue(data: boolean) {
        if (data) this.$router.push({ name: this.nextRoute, params: this.routeParams });
        this.nextRoute = "";
    }

    updateUser() {
        if (!this.passwordState || !this.currentPasswordState) {
            return;
        }
        this.saveClicked = true;
        this.userProfile.timezoneId = this.selectedTimeZone.id;
        this.updateUserCulture(this.userProfile.cultureCode);
        updateUserProfile(this.userProfile).then(() => {
            this.updateUsername(this.userProfile);
            if (this.$i18n.locale !== this.userProfile.cultureCode) {
                location.reload();
            }
        });
    }

    sendResetPassEmail() {
        resetPassword(this.userProfile.email, "Reset password from profile page").then(response => {
            response.mailSent ? this.emailResp = i18n.t("users.mailSent") : this.emailResp = i18n.t("login.mailNotSent");
            response.somethingBadHappen ? this.emailResp = i18n.t("users.incorectEmail") : this.editPassword = false;
        });
    }

    get passwordState(): boolean {
        if (this.userProfile.password.length === 0 && this.userProfile.repeatNewPassword.length === 0) {
            return true;
        }
        return this.userProfile.password === this.userProfile.repeatNewPassword &&
            this.userProfile.password.length >= 8 &&
            this.userProfile.repeatNewPassword.length >= 8;
    }

    get invalidPassword() {
        if (this.userProfile.password.length < 8 || this.userProfile.repeatNewPassword.length < 8) {
            return i18n.t("users.passwordLengthWarning");
        }
        if (this.userProfile.password !== this.userProfile.repeatNewPassword) {
            return i18n.t("users.passwordMismatch");
        }
        return "";
    }

    get validPassword() {
        if (this.userProfile.password.length === 0 && this.userProfile.repeatNewPassword.length === 0) {
            return "";
        }
        return i18n.t("users.passwordMatch");
    }

    get currentPasswordState(): boolean {
        if (this.userProfile.currentPassword.length === 0 &&
            this.userProfile.password && this.userProfile.password.length > 0) {
            return false;
        }
        return true;
    }

    get invalidCurrentPassword() {
        return i18n.t("users.currentPasswordRequired");
    }

    back() {
        window.history.go(-1);
    }

    togglePasswordVisibility() {
        if (this.passwordFieldType === "password") {
            this.passwordFieldType = "text";
        } else {
            this.passwordFieldType = "password";
        }
    }

    getLocalizedCulture() {
        var cultures = Cultures;
        return cultures
            .map(cul => ({ text: i18n.t(`languages.${cul.text}`), value: cul.code }));
    }

    // lifecycle hooks
    created() {
        this.fetchData();
    }
}
